module.exports = __webpack_public_path__ + "static/3-bill-65837122c182f417f485565276fa40bf.jpg";